import React from "react";
import { Button } from "antd";
import {FormattedMessage} from 'react-intl';

type SaveButtonProps = {
    disabled?: boolean
};

const SaveButton: React.FunctionComponent<SaveButtonProps> = ({ children, disabled })  => {
  return (
    <Button type="primary" disabled={disabled} htmlType="submit"><FormattedMessage id="system.save"/></Button>
  );
};

export default SaveButton; 


